module.exports = __webpack_public_path__ + "static/img/公司4.881da72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司4.jpg
// module id = fLM3
// module chunks = 1